import { AppConfig } from '~/interfaces/AppConfig';
import { getOnpremHostname } from 'omni-package-react-core';

export default class Configuration {
  private static config: AppConfig = {
    homePath: '/eemwpnp1/public/gologin/',
    mockingEnabled: process.env.REACT_APP_MOCK_API === 'true',
    publicUrl: process.env.PUBLIC_URL,
    businessEntityCode: process.env.REACT_APP_BUSINESS_ENTITY_CODE,
    forgetPasswordPath: process.env.REACT_APP_FORGET_PASSWORD_PATH,
    forgetUserNamePath: process.env.REACT_APP_FORGET_USERNAME_PATH,
    registrationPath: process.env.REACT_APP_REGISTRATION_PATH,
    domainName: process.env.REACT_APP_DOMAIN_NAME,
    onPremHostName: getOnpremHostname(),
    idpTenantUrl: `${document.location.origin}/`,
    oktaBookmarkClientIdAcura: process.env.REACT_APP_OKTA_BOOKMARK_CLIENT_ID_ACURA,
    oktaBookmarkClientIdGenesis: process.env.REACT_APP_OKTA_BOOKMARK_CLIENT_ID_GENESIS,
    oktaBookmarkClientIdHonda: process.env.REACT_APP_OKTA_BOOKMARK_CLIENT_ID_HONDA,
    oktaBookmarkClientIdHyundai: process.env.REACT_APP_OKTA_BOOKMARK_CLIENT_ID_HYUNDAI,
    oktaBookmarkClientIdAcuraSSO: process.env.REACT_APP_OKTA_BOOKMARK_CLIENT_ID_ACURA_SSO,
    oktaBookmarkClientIdGenesisSSO: process.env.REACT_APP_OKTA_BOOKMARK_CLIENT_ID_GENESIS_SSO,
    oktaBookmarkClientIdHondaSSO: process.env.REACT_APP_OKTA_BOOKMARK_CLIENT_ID_HONDA_SSO,
    oktaBookmarkClientIdHyundaiSSO: process.env.REACT_APP_OKTA_BOOKMARK_CLIENT_ID_HYUNDAI_SSO,
    oktaClientIdUnifi: process.env.REACT_APP_OKTA_UNIFI_CLIENT_ID,
    oktaObjectIdPPM: process.env.REACT_APP_OKTA_OBJECT_ID_PPM,
  };

  public static Current(): AppConfig { return Configuration.config; }
}
